import CRUDService from "../services/base/CRUDService";

export default class CheckpointService extends CRUDService {

  static ALL_URL = 'ton/v1/checkpoints';
  static COMMISSIONER_URL = 'ton/v1/checkpoints/commissioners';

  getBaseURL() {
    return "ton/v1/checkpoints/";
  }

  saveReadpoints(id, readpointsIds) {
    return this.getHttpRequest().put(`${this.getBaseURL()}${id}/readpoints`, readpointsIds);
  }

  saveProfiles(id, profileIds) {
    return this.getHttpRequest().put(`${this.getBaseURL()}${id}/profiles`, profileIds);
  }

  deleteCheckpointPointById(id) {
    return this.getHttpRequest().delete(`${this.getBaseURL()}/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/checkpoint/CheckpointService.js